import Logo from '../../assets/images/logo.png';
import styles from './Topline.module.css';

export const Topline = () => (
  <div className={styles.wrapper}>
    <img alt='' src={Logo} className={styles.logo} />
  </div>
);
